
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ResultModule from '@/store/modules/Result';
import Game from '@/components/Game.vue';
import GeneralControl from '@/store/modules/GeneralControl';

@Component({
  components: {
    Game,
  },
})
export default class FreePlay extends Vue {
  ResultInstance = getModule(ResultModule, this.$store);

  GeneralControlModule = getModule(GeneralControl, this.$store);

  queryData = {
    params: {
      roundId: this.$route.query.roundId || '',
    },
    token: this.$route.query.t || '',
  };

  resultList: string[] = [];

  currentResult = 0;

  currentLink = '';

  gameLink = '';

  @Watch('this.$route.query.p', { immediate: true, deep: true })
  changeLink() {
    this.handleLink(this.$route.query.p);
  }

  async created() {
    this.GeneralControlModule = getModule(GeneralControl, this.$store);
  }

  async handleLink(prefix: any) {
    const res = await this.GeneralControlModule.getLinkDemo(prefix);
    if (res.status.code === 0) {
      this.gameLink = res.data;
    } else {
      console.log('response getLink Demo : ', res);
    }
  }

  onChangeIframe(state: number) {
    this.currentResult += state;
    this.currentLink = this.resultList[this.currentResult];
  }
}
